import classnames from 'classnames';
import React from 'react';
import Box from './Box';
import './Button.css';
import Spinner from './Spinner';
import Text from './Text';

interface ButtonParams {
  pending?: boolean;
  onClick?(e: any): void;
  label?: string;
  children?: any;
  size?: string;
  width?: string;
  justifyContent?: string;
  hideLabel?: boolean;
  primary?: boolean;
}

function Button({
  pending = false,
  onClick,
  label,
  size,
  width,
  justifyContent,
  primary
}: ButtonParams) {
  const buttonClass = classnames(
    'Button',
    primary && 'Button--white',
    pending && 'Button--pending',
    size && `Button-size--${size}`,
    width && `Button-width--${width}`,
  );

  return (
    <button className={buttonClass} onClick={(e: any) => {
      if (pending) return;
      onClick && onClick(e);
    }}>
      <Box alignItems='center' justifyContent='center' width={justifyContent ? 'max' : ''}>
        {
          pending &&
          <Box paddingRight={8}>
            <Spinner size={'small'} color={'white'} />
          </Box>
        }
        <Text color={primary ? 'red' : 'white'}>
          {label}
        </Text>
      </Box>
    </button >
  );
}

export default Button;